"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuickJumperStyles = void 0;
var react_1 = require("@emotion/react");
var getQuickJumperStyles = function (theme) { return ({
    common: react_1.css({
        fontSize: 14,
        lineHeight: '21px',
        fontWeight: 400,
        color: theme.color.GRAY.DEFAULT,
    }),
    totalPages: react_1.css({
        color: theme.color.GRAY.DARK_4,
    }),
}); };
exports.getQuickJumperStyles = getQuickJumperStyles;
